export default {
  props: {
    total: {
      type: String,
      default: '0.00'
    },
    available: {
      type: String,
      default: '0.00'
    },
    claimCb: {
      type: Function,
    },
    claiming: {
      type: Boolean,
      default: false,
    },
    claimDisabled: {
      type: Boolean,
      default: false,
    }
    // items: {
    //   type: Array,
    //   default: () => [{ index: 0, text: 'Type address' }, { index: 1, text: 'Metamask connect' }]
    // }
  },
  computed: {},
  data () {
    return {
    }
  },
  methods: {
    set (item) {
      this.selected = item.index
      this.$emit('input', this.selected)
    },
    claim () {
      this.claimCb()
    }
  }
}
